import { ExamType } from '../../../models';
import { TestConfigData } from '../../test-configurator-provider';
import { TestConfigStepType } from '../test-config-steps-provider.interfaces';

export interface GetNextStepProps {
  currentStepType: TestConfigStepType;
  configData: TestConfigData;
}
export const getNextStepType = ({ currentStepType, configData }: GetNextStepProps): TestConfigStepType => {
  const { examType, hasChallenge, organizationIds } = configData;

  const getLastConditionalSteps = () => {
    if (organizationIds && organizationIds.length > 1) {
      return TestConfigStepType.SET_ORGANIZATION;
    }
    return TestConfigStepType.FINISH;
  };

  switch (currentStepType) {
    case TestConfigStepType.SET_OPPOSITION: {
      return TestConfigStepType.SET_EXAM_TYPE_OR_CHALLENGE;
    }
    case TestConfigStepType.SET_EXAM_TYPE_OR_CHALLENGE:
    case TestConfigStepType.SET_EXAM_TYPE: {
      if (examType) {
        switch (examType) {
          case ExamType.fails:
          case ExamType.blank:
          case ExamType.random:
          case ExamType.guest: {
            return TestConfigStepType.SET_NUM_QUESTIONS;
          }
          case ExamType.alleged:
          case ExamType.challenge:
          case ExamType.previousCall:
          case ExamType.demo: {
            return TestConfigStepType.SET_EXAM_TEMPLATE;
          }

          default: {
            if (hasChallenge) {
              return TestConfigStepType.CREATE_CHALLENGE;
            }
            return getLastConditionalSteps();
          }
        }
      }
      return TestConfigStepType.SET_EXAM_TYPE;
    }
    case TestConfigStepType.SET_NUM_QUESTIONS: {
      return TestConfigStepType.SET_CONTENTS;
    }
    case TestConfigStepType.SET_CONTENTS:
    case TestConfigStepType.SET_EXAM_TEMPLATE: {
      if (hasChallenge) {
        return TestConfigStepType.CREATE_CHALLENGE;
      }
      return getLastConditionalSteps();
    }
    case TestConfigStepType.CREATE_CHALLENGE: {
      return getLastConditionalSteps();
    }
  }
  return TestConfigStepType.FINISH;
};
